import type { FlowFilter } from '@/models/flowFilter.type';
import type { Ingestion } from '@/models/oru_collecte.types';

/** Ligne renvoyée par le flow : le `volume` (bigint SQL) arrive sous forme de chaîne. */
export type IngestionRow = Omit<Ingestion, 'volume'> & { volume: string | null };

/** Colonnes acceptées par le paramètre `orderBy` du flow (liste fermée). */
export const ingestionSortColumns = [
  'id',
  'date_heure_debut',
  'date_heure_fin',
  'manuel',
  'emetteur',
  'statut',
  'volume',
  'nb_element',
  'nb_succes',
  'nb_rejet',
  'nb_erreur',
  'fluxname',
  'sus',
] as const satisfies readonly (keyof IngestionRow)[];

export type IngestionSortColumn = (typeof ingestionSortColumns)[number];

export type IngestionSortDirection = 'asc' | 'desc';

export type IngestionsQueryArg = {
  page: number;
  pageSize: number;
  orderBy?: `${IngestionSortColumn} ${IngestionSortDirection}`;
  filter?: FlowFilter;
};

export type IngestionsPage = {
  rows: IngestionRow[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
};
